<template>
  <div class="detail_page">
    <el-tabs v-model="pageIndex" class="tabs-container">
      <el-tab-pane :label="$t('zlfk.jbxx')" name="problemDetailTab"></el-tab-pane>
      <el-tab-pane v-if="problemData.regionalManageReview === 1" :label="$t('zlfk.yjcs')"
        name="emergencyMeasureTab"></el-tab-pane>
      <el-tab-pane :label="$t('zlfk.cljl')" name="dealInfoTab"></el-tab-pane>
    </el-tabs>
    <div class="contentInfo">
      <div v-show="pageIndex === 'problemDetailTab'">
        <!-- 基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img src="@/assets/image/basicRed.png" alt="">
            {{ $t("zlfk.jbxx") }}
          </div>
        </div>
        <div class="form-container">
          <el-descriptions class="desc-container" :column="3" border>
            <!-- 问题序号 -->
            <el-descriptions-item :label="$t('zlfk.wtbh')">
              {{ problemData.questionNum }}
            </el-descriptions-item>
            <!-- 销售订单号 -->
            <el-descriptions-item :label="$t('zlfk.xsddh')">
              {{ problemData.orderNum }}
            </el-descriptions-item>
            <!-- 车型 -->
            <el-descriptions-item :label="$t('home.carType')">
              {{ problemData.carModel }}
            </el-descriptions-item>
            <!-- 订单车辆数量 -->
            <el-descriptions-item :label="$t('zlfk.ddclsl')">
              {{ problemData.carTotal }}
            </el-descriptions-item>
            <!-- 故障发生日期 -->
            <el-descriptions-item :label="$t('zlfk.gzfsrq')">
              {{ problemData.happenDate }}
            </el-descriptions-item>
            <!-- 严重程度 -->
            <el-descriptions-item :label="$t('restock.issueSeverity')">
              {{ problemData.issueSeverity }}
            </el-descriptions-item>
            <!-- 反馈单目的 -->
            <el-descriptions-item :label="$t('restock.feedbackPurpose')">
              {{ getFeedbackPurposeText(problemData.feedbackPurpose) }}
            </el-descriptions-item>
            <!-- 补件方式 -->
            <el-descriptions-item v-if="getFeedbackPurposeList(problemData.feedbackPurpose).includes('3')" :label="$t('restock.patchMode')">
              {{ getPatchModeText(problemData.patchMode) }}
            </el-descriptions-item>
            <!-- 故障配件数量 -->
            <el-descriptions-item :label="$t('zlfk.gzpjsl')">
              {{ problemData.faultTotal }}
            </el-descriptions-item>
            <!-- 是否重点问题 -->
            <el-descriptions-item :label="$t('zlfk.sfzdwt')">
              {{ problemData.importantType == 1 ? $t("seek.yes") : $t("seek.no") }}
            </el-descriptions-item>
            <!-- 重点问题描述 -->
            <el-descriptions-item label-class-name="custom-label" v-if="problemData.importantType === 1">
              <template slot="label">{{ $t("zlfk.zdwtms") }}</template>
              {{ problemData.importantDescribe }}
            </el-descriptions-item>

            <!-- 反馈单号 -->
            <!--          <el-descriptions-item :label="$t('zlfk.fkdh')">-->
            <!--            {{problemData.feedbackFormId}}-->
            <!--          </el-descriptions-item>-->
            <!-- 状态 -->
            <!--          <el-descriptions-item :label="$t('climant.status')">-->
            <!--            <span v-if="problemData.status == 0">{{$t('climant.noSubmit')}}</span>-->
            <!--            <span v-if="problemData.status == 1">{{$t('zlfk.clz')}}</span>-->
            <!--            <span v-if="problemData.status == 2">{{$t('zlfk.dqr')}}</span>-->
            <!--            <span v-if="problemData.status == 3">{{$t('zlfk.bbh')}}</span>-->
            <!--            <span v-if="problemData.status == 4">{{$t('home.closed')}}</span>-->
            <!--          </el-descriptions-item>-->
            <!-- 是否有维修措施 -->
            <el-descriptions-item :label="$t('zlfk.sfywxcs')">
              {{ problemData.serviceMeasure == 0 ? $t("seek.no") : $t("seek.yes") }}
            </el-descriptions-item>
            <!-- 客户海外KD工厂处置方案 -->
            <el-descriptions-item v-if="problemData.serviceMeasure == 1" :label="$t('restockInfo.kdcswxcs')"
              label-class-name="custom-label">
              {{ problemData.marketService }}
            </el-descriptions-item>
            <!-- 零部件类别 -->
            <el-descriptions-item :label="$t('restock.componentType')">
              <div v-for="(item, index) in componentCategoryList" :key="index">
                <div v-if="item.code == problemData.componentCategory">
                  {{ item[componentCategoryName.get($i18n.locale)] }}
                </div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <div style="margin-top: -15px;">
            <p
              style="border: 1px solid var(--table-color);border-bottom: none;border-top: none; padding: 10px 15px;font-weight: bold;font-size: 15px;">
              {{ $t("restock.gzpjbm") }}</p>
            <el-table ref="tableRef" :data="problemData.vinCheckRespList" :key="problemData.componentType" border stripe highlight-current-row>
              <el-table-column type="index" show-overflow-tooltip :label="$t('cart.xh')" width="50" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="outBoxNo" show-overflow-tooltip :label="$t('restock.wbzxh')" min-width="100" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="paperNo" show-overflow-tooltip :label="$t('restock.zxh')" min-width="100" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="faultCode" show-overflow-tooltip :label="$t('restock.pjbm')" min-width="100" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="faultName" show-overflow-tooltip min-width="100"  :label="$t('restock.pjmc')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="faultNumber" show-overflow-tooltip min-width="100" :label="$t('zlfk.gzpjsl')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="engineNo" v-if="problemData.componentType === 1" show-overflow-tooltip min-width="100" :label="$t('restock.engineNo')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="engineType" v-if="problemData.componentType === 1" show-overflow-tooltip min-width="100" :label="$t('restock.engineType')" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="scope">
                  {{ scope.row.engineType == 1 ? $t('restock.naturally') : scope.row.engineType }}
                </template>
              </el-table-column>
              <el-table-column prop="orderBatch" show-overflow-tooltip min-width="100" :label="$t('zlfk.ddpch')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="partBatchNo" show-overflow-tooltip min-width="100" :label="$t('restock.partBatchNo')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="supplierCode" show-overflow-tooltip min-width="100" :label="$t('restock.supplierCode')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="faultType" show-overflow-tooltip min-width="100" :label="$t('zlfk.gzlb')" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="scope">
                  <div v-for="(item, index) in kdFaultTypeList.filter(
                    (item) => item.codeText === $i18n.locale
                  )" >
                    <span v-if="item.code.replace(item.codeText, '') == scope.row.faultType">{{ item.value}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="repairPlan" show-overflow-tooltip min-width="100" :label="$t('zlfk.wxfa')" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="scope">
                  <div v-for="(item, index) in kdRepairPlanList.filter(
                    (item) => item.codeText === $i18n.locale
                  )" >
                    <span v-if="item.code.replace(item.codeText, '') == scope.row.repairPlan">{{ item.value}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="singleDosage" show-overflow-tooltip min-width="100" :label="$t('zlfk.dcyl')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="arrivalTime" show-overflow-tooltip min-width="100" :label="$t('restock.arrivalTime')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="unboxingTime" show-overflow-tooltip min-width="100" :label="$t('restock.unboxingTime')" align="center" :render-header="$globalRenderHeader"></el-table-column>
              <el-table-column prop="onlineTime" show-overflow-tooltip min-width="100" :label="$t('restock.onlineTime')" align="center" :render-header="$globalRenderHeader"></el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 问题描述 -->
        <div class="hearder-title" style="margin-top: 20px;">
          <div class="flex_between">
            <img src="@/assets/image/wtmsred.png" alt="">
            {{ $t("zlfk.wtms") }}
          </div>
        </div>
        <div class="form-container">
          <el-descriptions class="desc-container" :column="1" border>
            <el-descriptions-item :label="$t('restock.faultDescription')">
              {{ problemData.questionContent }}
            </el-descriptions-item>
            <!-- <el-descriptions-item :label="$t('zlfk.fj')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.faultDescriptionList"></file-upload-list>
            </el-descriptions-item> -->
          </el-descriptions>
        </div>

        <!-- 图片和视频 -->
        <div class="hearder-title" style="margin-top: 20px;">
          <div class="flex_between">
            <img src="@/assets/image/imgRed.png" alt=""></img>
            {{ $t("restock.pictureAndVideo") }}
          </div>
        </div>
        <div class="form-container">
          <el-descriptions class="desc-container" :column="1" border>
            <!-- { key: 'unboxOverallList', title: this.$t('restock.isUnboxOverall') },
            { key: 'boxLabelList', title: this.$t('restock.isBoxLabel') },
            { key: 'boxDamageList', title: this.$t('restock.isBoxDamage') },
            { key: 'partOverallList', title: this.$t('restock.isPartOverall') },
            { key: 'partDetailList', title: this.$t('restock.isPartDetail') },
            { key: 'partComparisonList', title: this.$t('restock.isPartComparison') },
            { key: 'supplierInfoList', title: this.$t('restock.isSupplierInfo') }, -->
<!--            { key: 'otherEvidenceList', title: this.$t('restock.isOtherEvidence') }-->
            <!-- 包装箱拆箱前整体图片/视频 -->
            <el-descriptions-item :label="$t('restock.isUnboxOverall')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.unboxOverallList"></file-upload-list>
            </el-descriptions-item>
            <!-- 包装箱粘贴标签图片 -->
            <el-descriptions-item :label="$t('restock.isBoxLabel')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.boxLabelList"></file-upload-list>
            </el-descriptions-item>
            <!-- 包装箱损坏局部图片/视频 -->
            <el-descriptions-item :label="$t('restock.isBoxDamage')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.boxDamageList"></file-upload-list>
            </el-descriptions-item>
            <!-- 零部件整体图片 -->
            <el-descriptions-item :label="$t('restock.isPartOverall')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.partOverallList"></file-upload-list>
            </el-descriptions-item>
            <!-- 零部件局部图片/视频 -->
            <el-descriptions-item :label="$t('restock.isPartDetail')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.partDetailList"></file-upload-list>
            </el-descriptions-item>
            <!-- 零部件对比图片(错/漏发/状态不对) -->
            <el-descriptions-item :label="$t('restock.isPartComparison')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.partComparisonList"></file-upload-list>
            </el-descriptions-item>
            <!-- 供应商信息图片 -->
            <el-descriptions-item :label="$t('restock.isSupplierInfo')">
              <file-upload-list ref="fileUploadList" :fileList="problemData.supplierInfoList"></file-upload-list>
            </el-descriptions-item>
            <!-- 其他辅助证据/视频资料 -->
            <el-descriptions-item :label="$t('restock.isOtherEvidence')" v-bind="descContentClass">
              <div :class="getRemarkClass(problemData.remark)">{{ problemData.remark }}</div>
              <file-upload-list ref="fileUploadList" v-if="problemData.otherEvidenceList.length > 0" :fileList="problemData.otherEvidenceList"></file-upload-list>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 临时措施 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/interimMeasure.png" alt="" />
              {{ $t("zlfk.temporary") }}
            </div>
          </div>
          <div>
            <el-descriptions class="desc-container" :column="1" border>
              <!-- 临时措施 -->
              <el-descriptions-item :label="$t('zlfk.temporary')" :labelStyle="{ width: '200px' }"
                :contentStyle="{ width: 'auto' }">
                {{provisionalMeasures}}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
      <div v-show="pageIndex === 'emergencyMeasureTab'">
        <emergency-measure :problemData="problemData" />
      </div>
      <div v-show="pageIndex === 'dealInfoTab'">
        <audit-record :recordList="recordList" />
      </div>
      <!-- 问题编辑修改组件 -->
      <problem-dialog ref="problemDialog" @success="getDetail" />
      <!-- 审核组件 -->
      <audit-dialog ref="auditDialog" @success="getDetail" />
      <!-- 故障配件列表 -->
      <parts-list-dialog ref="partsListDialog" />
    </div>
    <div class="footer-button">
      <el-button
        v-if="problemData.status === 0 || problemData.status === 3"
        class="primary-btn lang-but"
        size="small"
        type="primary"
        @click="handleEdit(problemData.status)"
      >{{ $t("zlfk.bjwt") }}</el-button> 
      <el-button
        v-if="problemData.status === 2"
        class="primary-btn lang-but"
        size="small"
        type="primary"
        @click="handleExamine('approval', true, 'accept')"
      >{{ $t("zlfk.rk") }}</el-button>
      <el-button
        v-if="problemData.status === 2"
        size="small"
        class="lang-but"
        type="danger"
        @click="handleExamine('approval', false, 'disagree')">{{ $t("message.bh") }}</el-button>
        <el-button
          v-if="problemData.status === 3"
          plain
          class="primary-btn lang-but"
          type="primary"
          @click="handelCancel"
        >{{ $t("seek.cancel") }}</el-button>
      <!-- <el-button class="primary-btn" plain size="small" type="primary" @click="back">{{ $t("operate.backList")
       }}</el-button> -->
    </div>
  </div>
</template>
<script>
import { getStorage, setStorageNew } from "@/util/localStor";
import { questionListApi, kdAuditHistoryList } from "@/api/qualityKD";
import AuditRecord from "./components/auditRecord.vue";
import EmergencyMeasure from "./components/emergencyMeasure.vue";
import problemDialog from "./components/problemDialog.vue";
import AuditDialog from "./components/auditDialog.vue";
import partsListDialog from "./components/partsListDialog.vue";
import faultData from "@/mixins/faultData";
import { getDictItem } from "@/util/dict";
export default {
  mixins: [faultData],
  components: {
    AuditRecord,
    EmergencyMeasure,
    problemDialog,
    AuditDialog,
    partsListDialog
  },
  data() {
    return {
      qualityData: {}, // 反馈单数据
      problemData: {}, // 问题数据
      pageIndex: "problemDetailTab", // 详情 | 记录
      provisionalMeasures: "",
      pageName: "zlfk.ckfkd",
      recordList: [],//处理记录
      kdFaultTypeList: [], // 故障类型列表
      kdRepairPlanList: [], // 维修方案列表
    };
  },
  computed: {
    // 图片视频内容className
    descContentClass(){
      return {
        contentClassName: "content-input",
      };
    },
  },
  watch: {
    "$i18n.locale"() {
      this.getInitializeInfo();
    }
  },
  async created() {
    this.getInitializeInfo();
  },
  methods: {
    getInitializeInfo() {
      this.getTypeList();
      // 反馈单数据
      this.qualityData = getStorage("qualityData");
      // 问题数据
      this.problemData = this.parseProblemData(getStorage("problemData"));
      this.sizeArea();
      this.getMeasureDetail()
      this.getMetaData();
      this.getkdFaultTypeList();
      this.getkdRepairPlanList();
    },
    // 获取车型列表
    async getkdFaultTypeList() {
      const res = await getDictItem("kdFaultType");
      this.kdFaultTypeList = res || [];
    },
    // 获取维修方案
    async getkdRepairPlanList() {
      const res = await getDictItem("kdRepairPlan");
      this.kdRepairPlanList = res || [];
    },
    // 返回上一步
    getMetaData() {
      if (sessionStorage.getItem('goBackPath')) {
        this.$route.meta.father = this.pageName;
        this.$route.meta.fatherPath = sessionStorage.getItem('goBackPath');
      }
    },
    back() {
      this.$router.go(-1);
    },
    // 备注className
    getRemarkClass(item) {
      return (item?.length) ? 'remarkInfo' : '';
    },
    // 获取临时措施
    async getMeasureDetail() {
      const res = await kdAuditHistoryList({
        data: { questionId: this.problemData.questionId },
      });
      this.recordList = res.data;
      this.recordList.forEach((item) => {
        if (item.provisionalMeasures) {
          this.provisionalMeasures = item.provisionalMeasures;
        }
      })
    },
    // 反馈单目的
    getFeedbackPurposeList(val) {
      return val ? String(val).split(",") : [];
    },
    getFeedbackPurposeText(val) {
      const map = {
        1: this.$t('restock.qualityImprove'),
        2: this.$t('restock.claimRecord'),
        3: this.$t('restock.urgentPart'),
        4: this.$t('restock.techAssist')
      };
      if (!val) return "";
      return String(val).split(",").map(v => map[v.trim()] || v.trim()).join(", ");
    },
    // 补件方式
    getPatchModeText(val) {
      const map = {
        1: this.$t('restock.patchModeAir'),
        2: this.$t('restock.patchModeKD'),
        3: this.$t('restock.patchModeParts')
      };
      return map[val] || "";
    },
    //  编辑问题
    handleEdit() {
      this.$refs.problemDialog.init(this.$t("zlfk.bjwt"), this.problemData);
    },
    // 审核问题
    handleExamine(field, value, dialogType) {
      var examineParams = {
        ...this.problemData,
        variables: {},
      };
      var title = "";
      var examineTip = `${this.$t("zlfk.wt")} ${examineParams.questionNum} `;
      examineParams.variables[field] = value;
      // 通过驳回
      if (field === "approval") {
        title = value ? "通过" : this.$t("message.bh");
        examineTip =
          examineTip +
          (value ? this.$t("home.passed") : this.$t("climant.rejected2"));
        if (dialogType === "accept") {
          title = this.$t("zlfk.rk");
          examineTip = `${this.$t("zlfk.wt")} ${examineParams.questionNum
            } ${this.$t("zlfk.yrk")}`;
        }
      }
      this.$refs.auditDialog.init(title, examineTip, examineParams, dialogType);
    },
    handelCancel() {
      this.getKDDealerCancel();
    },
    // 故障配件编码
    handlePartInfo() {
      this.$refs.partsListDialog.init(this.problemData.vinCheckRespList);
    },
    // 解析问题数据
    parseProblemData(data) {
      if (!data) return {};
      let newData = { ...data };
      if (newData.questionDescriptionAndFiles) {
        try {
          let qdf = newData.questionDescriptionAndFiles;
          if (typeof qdf === 'string') {
            qdf = JSON.parse(qdf);
          }
          if (qdf && typeof qdf === 'object') {
            newData = { ...newData, ...qdf };
          }
        } catch (e) {
          console.error("Failed to parse questionDescriptionAndFiles", e);
        }
      }
      return newData;
    },
    // 获取问题详情
    async getDetail() {
      const res = await questionListApi({
        data: {
          feedbackFormId: this.problemData.feedbackFormId,
          questionNum: this.problemData.questionNum,
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
      });
      this.problemData = this.parseProblemData({ ...res.data?.records[0] });
      setStorageNew("problemData", this.problemData);
    },
    // 内容高度
    heightSize() {
      setTimeout(() => {
        var allHeight = $(".detail_page").height();
        var tabHeight = $(".tabs-container").outerHeight(true);
        var footerHeight = ($(".footer-button")?.length > 0 ) ? $(".footer-button").outerHeight(true) : 0;
        const val = allHeight - tabHeight - footerHeight;
        $(".contentInfo").css("height", val);
      }, 100);
    },
    sizeArea() {
      var _this = this;
      _this.heightSize();
      window.addEventListener("resize", function () {
        _this.heightSize();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail_page {
  .top-container {
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }

    .el-button,
    .el-button--small {
      font-size: 13px !important;
      padding: 8px 12px !important;
    }
  }
}

.file-list {
  display: flex;
  flex-wrap: wrap;

  .file-item {
    margin-right: 15px;
    margin-bottom: 10px;
    cursor: pointer;
    text-align: center;
    width: 100px;

    .file-icon {
      width: 40px;
      height: 40px;
      display: block;
      margin: 0 auto 5px;
    }

    .file-thumb {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border: 1px solid #eee;
      border-radius: 4px;
    }

    .generic-file {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f7fa;
      border: 1px solid #eee;
      border-radius: 4px;

      i {
        font-size: 32px;
        color: #909399;
      }
    }

    .file-name {
      font-size: 12px;
      color: #606266;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 5px;
    }
  }
}
</style>
